import { getValueInCurrency } from '../../../common/utils';
import { getCurrencyFromSetup } from '../../../common/EntitiesManagement';
import NoDataLabel from '../../../components/common/NoDataLabel';

export default function PaymentTypeValue({
  generatesPaymentToTechnician,
  paymentValue,
  paymentMode,
}) {
  const getPaymentValueDate = () => {
    if (!generatesPaymentToTechnician) {
      return <NoDataLabel />;
    }

    switch (paymentMode) {
      case 'PERCENTAGE':
        return `${paymentValue} %`;
      case 'FIXED':
        return getValueInCurrency(getCurrencyFromSetup(), paymentValue);
      default:
        return <NoDataLabel />;
    }
  };

  return getPaymentValueDate();
}
